import { Lead } from "@app/dashboard/dashboard.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const leadsAdapter: EntityAdapter<Lead> = createEntityAdapter<Lead>({
	selectId: lead => lead.opportunityId,
});